/** @jsxImportSource react */
import styled from "styled-components";

export const Mask = styled.div({
    overflow: "hidden"
});

export const Frame = styled.div({
    "display": "flex",
    "flexDirection": "column",
    "flex-direction": "column",
    "gap": "1.5rem"
});

export const Track = styled.div({
    "alignItems": "stretch",
    "align-items": "stretch",
    "display": "flex"
});

export const Slide = styled.div({
    "boxSizing": "content-box",
    "box-sizing": "content-box",
    "userSelect": "none",
    "user-select": "none",
    "width": "100%"
});

type ControlsProps = {
    alignStart?: boolean;
};

const ControlsStyled = styled.div({
    "alignItems": "center",
    "align-items": "center",
    "justifyContent": "space-around",
    "justify-content": "space-around",
    "gap": "1.5rem",
    "display": "flex"
});

export const Controls = ControlsStyled;

export const MobileControls = styled.div({
    "alignItems": "center",
    "align-items": "center",
    "justifyContent": "center",
    "justify-content": "center",
    "gap": "1.5rem",
    "display": "flex",
    "flexWrap": "wrap",
    "flex-wrap": "wrap",
    "position": "relative",
    "zIndex": 1,
    "z-index": 1,
    "@media (min-width: 992px)": {
        display: "none"
    }
});

export const DesktopControls = styled.div<ControlsProps>(({ alignStart }) => ({
    "alignItems": "center",
    "align-items": "center",
    "justifyContent": alignStart ? "flex-start" : "flex-end",
    "justify-content": alignStart ? "flex-start" : "flex-end",
    "gap": "1.5rem",
    "display": "none",
    "flexWrap": "wrap",
    "flex-wrap": "wrap",
    "position": "relative",
    "zIndex": 1,
    "z-index": 1,
    "@media (min-width: 992px)": {
        display: "flex"
    }
}));

type DotsProps = {
    mobile?: boolean;
    desktop?: boolean;
};

export const Dots = styled.div<DotsProps>(({ mobile, desktop }) => ({
    "alignItems": "center",
    "align-items": "center",
    "display": mobile || desktop ? "flex" : "none",
    "gap": "0.5rem"
}));

type DotProps = {
    transitionTimeInSeconds: number;
};

export const Dot = styled.button<DotProps>(({ transitionTimeInSeconds }) => ({
    "backgroundColor": "currentcolor",
    "background-color": "currentcolor",
    "border": 0,
    "borderRadius": "0.25rem",
    "border-radius": "0.25rem",
    "color": "inherit",
    "cursor": "pointer",
    "display": "block",
    "height": "0.5rem",
    "padding": 0,
    "width": "0.5rem",
    "transition": `all ${transitionTimeInSeconds}s ease`
}));
